<template>
	<div class="d-flex flex-row align-content-center px-0">
		<botao-tooltip
			icone="mdi-pencil"
			cor="grey"
			texto="Editar"
			@click="editar"
			v-az-auth="permissoes.revisoesEditar"
		></botao-tooltip>
		<botao-tooltip
			v-if="exibirAcaoVisualizar"
			icone="mdi-eye-outline"
			cor="grey"
			texto="Visualizar"
			@click="visualizar"
			v-az-auth="permissoes.revisoesVisualizar"
		></botao-tooltip>
		<botao-tooltip
			icone="mdi-delete"
			cor="grey"
			texto="Excluir"
			@click="excluir"
			v-az-auth="permissoes.revisoesExcluir"
		></botao-tooltip>
	</div>
</template>

<script>
import BotaoTooltip from '@/views/components/BotaoTooltip.vue'
import { situacoesRevisao } from '@/core/constants'

export default {
	name: 'revisoes-listagem-botoes-acoes',
	components: { BotaoTooltip },
	props: {
		item: {
			type: Object,
			required: true,
		},
	},
	emits: ['editar', 'excluir', 'visualizar'],
	computed: {
		exibirAcaoVisualizar() {
			return this.item.situacao === situacoesRevisao.FINALIZADO.value
		},
	},
	methods: {
		editar() {
			this.$emit('editar', this.item)
		},
		excluir() {
			this.$emit('excluir', this.item.id)
		},
		visualizar() {
			this.$emit('visualizar', this.item.id)
		},
	},
}
</script>
